// GET /brands/{brandUuid}/profile → the groups and sections the Brand Profile
// tab renders.
const byDisplayOrder = (first, second) =>
  first.display_order - second.display_order

export const mapBrandProfile = (response) => {
  const groups = [...response.section_groups]
    .sort(byDisplayOrder)
    .map((group) => ({
      id: group.section_group_uuid,
      label: group.group_name || '',
      sections: [...group.sections].sort(byDisplayOrder).map((section) => ({
        id: section.section_uuid,
        title: section.section_name,
        value: section.section_value,
      })),
    }))

  return {
    groups,
    sectionCount: groups.reduce(
      (total, { sections }) => total + sections.length,
      0,
    ),
  }
}
